import { type JSX } from 'react';

import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAppDispatch } from 'app/hooks';
import { setColumnSettingsDialogOpen } from 'common/components/columnSettingsDialog/columnSettingsSlice';
import { TooltipIcon } from 'common/components/TooltipIcon';

const BUTTON_TEST_ID = 'settings-data-grid-button-test-id';

export function SettingsButton(): JSX.Element {
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const settingsIconTooltipDescription = 'Settings';

    const settingsIconWithTooltip = (
        <TooltipIcon
            IconComponent={SettingsOutlinedIcon}
            tooltipTitle={settingsIconTooltipDescription}
            iconColor='primary'
            iconInlineStyles={{ color: theme.palette.primary.accent as string }}
        />
    );

    return (
        <Button
            sx={{
                padding: '4px',
                minWidth: 'auto',
                marginRight: '1.5rem',
                border: null,
                backgroundColor: 'transparent'
            }}
            onClick={() => dispatch(setColumnSettingsDialogOpen(true))}
            data-testid={BUTTON_TEST_ID}
        >
            {settingsIconWithTooltip}
        </Button>
    );
}
